var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsDateString, IsOptional, IsString, ValidateIf } from 'class-validator';
export class UpdatePriceListDto {
    name;
    validFrom;
    validTo;
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdatePriceListDto.prototype, "name", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdatePriceListDto.prototype, "validFrom", void 0);
__decorate([
    ValidateIf((o) => o.validTo !== null),
    IsDateString(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdatePriceListDto.prototype, "validTo", void 0);
//# sourceMappingURL=update-price-list.dto.js.map